export default __webpack_public_path__ + "static/media/rifDamascus.93a429da.jpg";